import { ApiManager } from './ApiManager';
import { MessageTemplateDTO } from './models/MessageTemplateDTO';

export default class ApiMessageTemplatesManager {
  static async getMessageTemplates(): Promise<MessageTemplateDTO[]> {
    const apiManager = ApiManager.getInstance();
    const response = await apiManager.get(`/api/message-templates/`);
    return response.data as MessageTemplateDTO[];
  }

  static async createMessageTemplate(params: {
    name: string;
    message_text: string;
    rank?: number;
  }): Promise<MessageTemplateDTO> {
    const apiManager = ApiManager.getInstance();
    const response = await apiManager.post(`/api/message-templates/`, params);
    return response.data as MessageTemplateDTO;
  }

  static async updateMessageTemplate(
    id: string,
    params: { name?: string; message_text?: string; rank?: number },
  ): Promise<MessageTemplateDTO> {
    const apiManager = ApiManager.getInstance();
    const response = await apiManager.patch(`/api/message-templates/${id}/`, params);
    return response.data as MessageTemplateDTO;
  }

  static async deleteMessageTemplate(id: string): Promise<void> {
    const apiManager = ApiManager.getInstance();
    await apiManager.delete(`/api/message-templates/${id}/`);
  }
}
